import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaymentDetailViewModel } from '../../../../common/model/payment/paymentDetailViewModel';
import { ActionType } from '../../../actions/model';

export interface AdminPaymentsDetailsState {
    list: PaymentDetailViewModel[] | null;
    isLoading: boolean;
    isLoaded: boolean;
}

const initialState: AdminPaymentsDetailsState = {
    list: null,
    isLoading: false,
    isLoaded: false,
};

export const adminPaymentDetailsSlice = createSlice({
    name: '@@vp/users/users/list',
    initialState,
    reducers: {
        setPaymentDetailsList(state, action: PayloadAction<PaymentDetailViewModel[]>): void {
            state.list = action.payload;
            state.isLoaded = true;
        },
        setLoading(state, action: PayloadAction<AdminPaymentsDetailsState['isLoading']>): void {
            state.isLoading = action.payload;
        },
        clearPaymentDetails(state): void {
            state.list = null;
            state.isLoading = false;
            state.isLoaded = false;
        },
    },
    extraReducers: {
        [ActionType.LOGOUT]: (): AdminPaymentsDetailsState => initialState,
    }
});

export const {
    setPaymentDetailsList,
    setLoading,
    clearPaymentDetails
} = adminPaymentDetailsSlice.actions;
